import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { StatesController } from "./states.controller";
import { StatesService } from "./states.service";
import { StatesEntity } from "./states.entity";
import { ApplicationExceptionHandler } from "libs/shared-utils/error-messages/src/lib/global-errors/application-exception-handler";


@Module({
  imports: [TypeOrmModule.forFeature([StatesEntity])],
  providers: [StatesService,ApplicationExceptionHandler],
  controllers: [StatesController],
})
export class StatesModule {}
